export const testimonials = [
  {
    name: '张明远',
    role: '独立开发者',
    content: '这个资源导航平台帮我节省了大量搜索时间。通过推荐的GitHub Pages + Jekyll方案，我用一个周末就搭建好了个人技术博客，完全零成本。网站上整理的免费资源非常全面，特别是CDN和SSL证书的教程，让我少走了很多弯路。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20avatar%2C%20warm%20lighting%2C%20simple%20cream%20background%2C%20friendly%20smile%2C%20modern%20business%20casual%20style%2C%20clean%20minimalist%20headshot&width=96&height=96&seq=avatar-01&orientation=squarish',
  },
  {
    name: '李思婷',
    role: '自由设计师',
    content: '作为设计师，我一直想拥有自己的作品集网站但预算有限。这个网站推荐的Carrd免费建站方案太适合我了，拖拽几下就做出了满意的作品集。现在客户都夸我的网站专业，感谢这个平台的精心整理！',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20avatar%2C%20warm%20lighting%2C%20simple%20cream%20background%2C%20confident%20smile%2C%20modern%20creative%20style%2C%20clean%20minimalist%20headshot&width=96&height=96&seq=avatar-02&orientation=squarish',
  },
  {
    name: '王浩然',
    role: '创业公司CEO',
    content: '创业初期资金紧张，通过这个导航站找到了完整的免费建站方案。从域名到主机再到SSL证书全部免费，让我们在零预算的情况下也能拥有专业的企业官网。强烈推荐给所有初创团队！',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20avatar%2C%20warm%20lighting%2C%20simple%20cream%20background%2C%20friendly%20expression%2C%20modern%20business%20style%2C%20clean%20minimalist%20headshot&width=96&height=96&seq=avatar-03&orientation=squarish',
  },
];